import React from 'react'
import AristCover from '../components/AristCover'
import { useSelector } from 'react-redux'

export default function Favorites() {
  const favorites = useSelector((state) => state.favoritReducer.favorites)

  return (
    <div>
      <h1>Users Favorit</h1>
      <div className="row d-flex justify-content-center">
        {favorites.map(artis => {
          return (
            <div
              key={artis.strArtist}
              className="col-3 mt-3">
              <AristCover
                artis={artis}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
